<div class="invite-user-card">
  <app-meeting-user-card class="user" [user]="userCard"></app-meeting-user-card>
  <div class="actions">
    <ng-container *ngIf="!isInvited; else invited">
      <span class="action" (click)="onInvite()"
            data-test="invite-user"> {{ 'classrooms.invite.invite' | customLocale }}</span>
    </ng-container>
    <ng-template #invited>
      <span class="status"> {{ 'classrooms.invite.invitation-sent' | customLocale }}</span>
    </ng-template>
  </div>
</div>
